import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import {  ProductsListResponse, ReviewInfo, SubmitResponse } from "../../models";
import { HttpService } from "./http.service";
import { Observable, catchError, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BrowseHistoryService extends HttpService<string, ProductsListResponse> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'browsing-history');
  }

  getbrowseHistoryProductsVarients(page=1,limit=30): Observable<ProductsListResponse> {
    return this.getAll('me?limit=30') as Observable<ProductsListResponse>;
  }
  
}